import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';

/* eslint-disable-next-line no-restricted-imports, @atlassian/tangerine/import/entry-points */

import debounce from 'lodash/debounce';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var MIN_INPUT_CHAR_LENGTH = 1;
export var useArticleSearch = function useArticleSearch(searchResponse) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var clearSearch = function clearSearch() {
    setIsLoading(false);
    setData(undefined);
  };
  var handleSearch = useMemo(function () {
    return debounce(function (searchInput) {
      var _searchResponse$helpO;
      if (searchInput.length < MIN_INPUT_CHAR_LENGTH) {
        return;
      }
      setIsLoading(true);
      setData(undefined);
      var edges = (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges;
      if (edges) {
        var resultData = edges.map(function (_ref) {
          var node = _ref.node;
          var id = node.id,
            title = node.title,
            contentType = node.contentType,
            urlInfo = node.urlInfo;
          if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.viewUrl) {
            return {
              id: id,
              title: title,
              type: contentType.toString(),
              url: urlInfo.viewUrl
            };
          }
          return null;
        }).filter(function (item) {
          return item !== null;
        });
        setData(resultData);
        setIsLoading(false);
      }
    }, 250);
  }, [searchResponse]);
  useEffect(function () {
    return function () {
      return handleSearch.cancel();
    };
  }, [handleSearch]);
  return {
    handleSearch: handleSearch,
    clearSearch: clearSearch,
    isLoading: isLoading,
    data: data
  };
};